import ButtonV2 from 'components/common/ButtonV2';
import FormikCheckboxField from 'components/Fields/FormikCheckboxField';
import FormikInputField from 'components/Fields/FormikInputField';
import { Field } from 'formik';
import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';

const CommissionForm = ({ values, setFieldValue, onSaveCommission }) => {
  const [saveButtonLoading, setSaveButtonLoading] = React.useState(false);

  const onClickSave = async () => {
    try {
      setSaveButtonLoading(true);
      await onSaveCommission();
    } catch (error) {
      console.error({ error });
    } finally {
      setSaveButtonLoading(false);
    }
  };

  return (
    <div>
      <Row>
        <Col sm={6}>
          <Field
            id=""
            name="sellerCommissionJson.CommissionWithoutDiscount"
            type="text"
            label="Seller’s Commission (p/kg)"
            component={FormikInputField}
            placeholder="0.0"
            disabled
          />
        </Col>
        <Col sm={6}>
          <Field
            id="commissionInfo.street"
            name="sellerDiscountAmount"
            type="text"
            label="Seller’s Flat Discount Price"
            component={FormikInputField}
            placeholder="0.0"
            disabled={
              values?.sellerCommissionAmount === 0 ||
              values?.sellerCommissionAmount === null ||
              values?.sellerCommissionAmount === undefined
            }
          />
        </Col>
        <Col sm={6}>
          <Field
            id="buyerCommissionAmount"
            name="buyerCommissionJson.CommissionWithoutDiscount"
            type="text"
            label="Buyer’s Commission (p/kg)"
            component={FormikInputField}
            placeholder="0.0"
            disabled
          />
        </Col>
        <Col sm={6}>
          <Field
            id="buyerDiscountAmount"
            name="buyerDiscountAmount"
            type="text"
            label="Buyer’s Flat Discount Price"
            component={FormikInputField}
            placeholder="0.0"
            disabled={
              values?.buyerCommissionAmount === 0 ||
              values?.buyerCommissionAmount === null ||
              values?.buyerCommissionAmount === undefined
            }
          />
        </Col>
      </Row>
      <Row>
        <Field
          type="checkbox"
          label="Exclude cumulative Qty of that month"
          name="excludeCumulativeQuantityForThatMonth"
          component={FormikCheckboxField}
        />
      </Row>
      <Row>
        <div style={{ textAlign: 'right' }}>
          <ButtonV2
            style={{ fontWeight: '400' }}
            size="sm"
            className="border-radius-4"
            color="primary"
            key="edit"
            onClick={() => onClickSave(true)}
          >
            Update
          </ButtonV2>
        </div>
      </Row>
    </div>
  );
};

export default CommissionForm;
